export default __webpack_public_path__ + "static/hero-phone-9ed9236b40cd5c680065997aa6ee1596.jpg";